import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const successToast = msg => toast.success(msg);
export const ErrorToast = msg => toast.error(msg);
